var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Card, CardFooter, CardHeader } from "./ui/card";
import { Settings } from "lucide-react";
export function AddonCard({ name, description, type, enabled, onToggle, onConfigure, }) {
    var _a;
    const { ajax_url, nonce } = (_a = window.SPWAAdmin) !== null && _a !== void 0 ? _a : {};
    if (!ajax_url || !nonce) {
        throw new Error("SPWAAdmin is not available. Did you enqueue wp_localize_script?");
    }
    const addonSlug = name
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
    const handleToggle = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`/wordpress/wp-json/spwa/v1/addon-toggle`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": nonce,
                },
                body: JSON.stringify({
                    addon_slug: addonSlug,
                    enabled: !enabled,
                }),
            });
            const data = yield response.json();
            if (data.success) {
                onToggle === null || onToggle === void 0 ? void 0 : onToggle(!enabled);
            }
            else {
                console.error("Toggle failed:", data.message);
                alert("Failed to update addon. Check console for details.");
            }
        }
        catch (err) {
            console.error("Request error:", err);
            alert("An error occurred while toggling the addon.");
        }
    });
    return (_jsxs(Card, { className: "group hover:shadow-md transition-shadow duration-200 border border-border h-full flex flex-col", children: [_jsx(CardHeader, { className: "pb-2 md:pb-3 flex-1 p-3 md:p-6", children: _jsxs("div", { className: "flex items-start justify-between gap-2 md:gap-3", children: [_jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("h3", { className: "font-medium leading-tight text-sm break-words", children: name }), _jsx("p", { className: "text-xs text-muted-foreground mt-1 line-clamp-2 md:line-clamp-3 break-words leading-relaxed", children: description })] }), _jsx(Badge, { variant: type === "premium" ? "default" : "secondary", className: `${type === "premium"
                                ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
                                : "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100"} flex-shrink-0 text-[10px] md:text-xs px-1.5 md:px-2 py-0.5 h-auto`, children: type === "premium" ? "Premium" : "Free" })] }) }), _jsx(CardFooter, { className: "px-3 md:px-6 pb-3 pt-0 flex flex-col gap-2 md:gap-3", children: _jsxs("div", { className: "flex items-center justify-between w-full", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Switch, { checked: enabled, onCheckedChange: handleToggle, className: "data-[state=checked]:bg-primary scale-75 md:scale-100" }), _jsx("span", { className: "text-xs text-muted-foreground", children: enabled ? "Enabled" : "Disabled" })] }), _jsxs(Button, { variant: "outline", size: "sm", 
                            // onClick={onConfigure}
                            disabled: !enabled, className: "flex items-center gap-1.5 hover:bg-accent text-xs h-7 px-2 md:h-8 md:px-3", children: [_jsx(Settings, { className: "w-3 h-3" }), _jsx("span", { className: "lg:block hide" }), _jsx("span", { className: "lg:hide" })] })] }) })] }));
}
